import ManageActionColumn from "../../../components/common/BreadTabulatorActionButton.vue";

import Vue from "vue";
import Vuetify from "vuetify";
import store from "../../../store";
import router from "../../../router";

export default {
  serviceKey: "sso",
  key: "internalRole",
  column: {
    uid: "slug", // tell the system which column to be used as unique id
    text: "name", // tell the system which column to display as text
  },
  name: {
    singular: "Role",
    plural: "Roles",
  },
  parents: ["internalDepartment"],

  apiUrls: {
    apiBrowseUrl: "",
    apiStoreUrl: "",
    apiUpdateUrl: "",
    apiReadUrl: "",
    apiMultiUpdateUrl: "",
    apiTrashedBrowseUrl: "",
    apiSoftDeleteUrl: "",
    apiHardDeleteUrl: "",
    apiRestoreUrl: "",
  },

  permissionKeys: {
    browse: "sso-internalRole-browse",
    read: "sso-internalRole-read",
    add: "sso-internalRole-add",
    edit: "sso-internalRole-edit",
    delete: "sso-internalRole-delete",
    restore: "sso-internalRole-restore",
    forceDelete: "sso-internalRole-forceDelete",
  },

  recordAccessControl: {
    browse: {
      all: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      own: {
        roles: ["superadmin"],
        apiUrl: "",
      },
      assignedTo: {
        roles: ["salesperson", "sales-lead"],
        apiUrl: "",
      },
      belongsTo: {
        ssoBusiness: {
          roles: ["superadmin"],
          apiUrl: "",
        },
        ssoTeam: {
          roles: ["superadmin"],
          apiUrl: "",
        },
      },
    },
  },

  roleBasedFunctionalities: {
    browse: {
      all: ["superadmin"],
      own: ["salesperson"],
      team: ["sales-lead"],
    },
  },

  browse: {
    // alert:{
    //   text:[
    //     "Kindly contact superadmin if you need to add/edit/delete the data.",
    //   ],
    // },

    tools: {
      // Roles are neither uploaded in bulk nor exported, so the browse page
      // drops the Upload / Export As / Selected buttons for this model.
      enableUpload: false,
      enableExport: false,
    },

    table: {
      actions: {
        manageCellEdit: true,
        columnSelectionDisabledCount: 3,
        isActionColumnVisible: true,
        isTrashedTabVisible: true,
      },
      headers: [
        {
          formatter: "rowSelection",
          titleFormatter: "rowSelection",
          titleFormatterParams: {
            rowRange: "active", //only toggle the values of the active filtered rows
          },
          hozAlign: "left",
          headerSort: false,
          filterable: false,
          searchable: false,
          headerFilter: false,
          selectableColumn: false,
          visible: true,
          download: false,
        },

        {
          title: "Index",
          formatter: (cell) => {
            return cell.getRow().getData().rownum;
          },
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: false,
          visible: true,
          download: false,
        },

        /* {
          title: "Department",
          field: "internalDepartmentSlug",
          dataType: "modelParent",
          modelKey: "internalDepartment",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: true,
          selectableColumn: true,
          hozAlign: "left",
        }, */
        {
          title: "Name",
          field: "name",
          dataType: "string",
          filterable: true,
          searchable: true,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
        },
        {
          title: "Slug",
          field: "slug",
          dataType: "string",
          filterable: true,
          searchable: true,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
        },

        {
          title: "Users",
          field: "_count.InternalRoleToInternalUser",
          dataType: "number",
          filterable: false,
          searchable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          editable: false,
        },

        /* {
          dataType: "model",
          relationship: "child",
          modelKey: "internalRoleToInternalUser",
          text: "Users",
          sortable: false,
          searchable: false,
          filterable: false,
        }, */

        {
          title: "Action",
          formatter: (cell) => {
            Vue.use(Vuetify);
            let ComponentClass = Vue.extend(ManageActionColumn);
            let instance = new ComponentClass({
              propsData: {
                cellData: cell.getData(),
                cellValue: cell.getValue(),
                cellRowData: cell.getRow().getData(),
                serviceKey: "sso",
                modelKey: "internalRole",
                modelId: cell.getRow().getData().id,
              },
              vuetify: new Vuetify({}),
              store,
              router,
            });
            instance.$mount();
            return instance.$el;
          },
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "internalRoleToInternalUser", //key for tab
        label: "Users",
        dataType: "model",
        relationship: "intermediate",
        modelKey: "internalRoleToInternalUser",
        intermediateChildModelKey: "internalUser",
        mapping: {
          parent: "slug",
          child: "internalRoleSlug",
        },
      },
      {
        key: "crmServicePermissionToInternalRole", //key for tab
        label: "Permissions",
        dataType: "model",
        relationship: "intermediate",
        modelKey: "crmServicePermissionToInternalRole",
        intermediateChildModelKey: "crmServicePermission",
        mapping: {
          parent: "slug",
          child: "internalRoleSlug",
        },
      },
    ],
    table: {
      headers: [
        /* {
          dataType: "model",
          relationship: "parent",
          modelKey: "internalDepartment",
          title: "Department",
          field: "internalDepartment",
        }, */
        {
          title: "Name",
          field: "name",
        },
        {
          title: "Slug",
          field: "slug",
        },
        {
          title: "Created",
          field: "timestampCreated",
        },
        {
          title: "Updated",
          field: "timestampUpdated",
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "internalDepartmentSlug",
        name: "Department",
        modelKey: "internalDepartment",
        optionText: "name",
        optionValue: "slug",
      },
      {
        type: "string",
        name: "Name",
        key: "name",
      },
      {
        type: "string",
        name: "Slug",
        key: "slug",
      },
    ],
    rules: {
      internalDepartmentSlug: ["required"],
      name: ["required"],
      slug: ["required"],
    },
  },
  edit: true,
  delete: true,
};
